import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import BtnMenu from '../../components/buttonDropdown';
import ImgHolder from '../../components/imgHolder';
import { useGroupChatContext } from '../../context/groupchatContext';
import { chatApi, useGetPatientQuestionsQuery, useGetProviderQuery } from '../../services/chatService';
import StopWatchPopup from './stopwatchPopup';
import MainPageDialog from '../../components/dialog';
import PushdownMenu from '../../components/pushdownMenu';
import { debounce } from 'lodash';
import { MagnifyingGlassIcon, PhoneIcon, UsersIcon } from '@heroicons/react/20/solid';
import TwilioDialer from '../twilio/dialer';
import MarkdownToHtml from '../../components/markdownToHtml';
import { toast } from 'react-toastify';
import { calculateAge, isPatientChatMessage } from '../../helpers/utility';
import ChatMembersPopup from './memberPopup';
import { OptimalCarePracticeID } from '../../utils/constant';
import { useGetLocationConfigurationQuery } from '../../services/location_services';
const defaultOptions = [{
    slug: 'change_status',
    label: 'Change Status'
}]

const isEnabled = (value) => value == 1 || value === true;

const MessageThreadHeader = React.memo(({ onSelectHeaderOption }) => {

    const actionOptions = [
        // {slug: 'provider_notes', label: 'Provider Notes', from: 'actions'},
        { slug: 'print_messages', label: 'Print Chat', from: 'actions' }
    ]
    const {
        practice: { id: practice_id },
        auth: authToken,
    } = JSON.parse(localStorage.getItem("auth"));

    const menuWrapperRef = useRef();
    const urgentCheckboxRef = useRef(null);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchMessages, setSearchMessages] = useState([]);
    const [IsSearchingMessages, setIsSearchingMessages] = useState(false);
    const [wantsToSearchMessage, setWantsToSearchMessage] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [isStopwatchPaused, setIsStopwatchPaused] = useState(true);
    const [isOpenDialer, setIsOpenDialer] = useState(false);
    const [showAcknowledgement, setShowAcknowledgement] = useState({ isOpen: false });
    const [isOpenMembersPopup, setIsOpenMembersPopup] = useState(false);

    const [formState, setFormState] = useState({
        date: moment(),
        activity: '',
        provider: '',
        comments: '',
        hours: '00',
        minutes: '00',
        seconds: '00'
    });

    const updatesetIsPaused = (newValue) => {
        setIsStopwatchPaused(newValue);
    };
    const updatesetFormState = (newValue) => {
        setFormState(newValue);
    }
    const updatestarttime = (newValue) => {
        setStartTime(newValue);
    }
    const formatTime = (time) => {
        return time.toString().padStart(2, '0');
    };
    const [reportOptions, setReportOptions] = useState([]);
    const groupChatContext = useGroupChatContext();

    const {authData, selectedChat, setProblemsMeta, isStopwatchActive, setIsStopwatchActive,setIsOpenStopWatchPopup,
        isOpenStopWatchPopup,setElapsedTime, elapsedTime, setSearchedMessageThread, setHighlightedMessageId, callData, messages, setMessages, isUrgentMessage, setIsUrgentMessage, selectedChatTab} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        setProblemsMeta: groupChatContext.setProblemsMeta,
        isStopwatchActive: groupChatContext.isStopwatchActive,
        setIsStopwatchActive: groupChatContext.setIsStopwatchActive,
        isOpenStopWatchPopup: groupChatContext.isOpenStopWatchPopup,
        setIsOpenStopWatchPopup: groupChatContext.setIsOpenStopWatchPopup,
        elapsedTime: groupChatContext.elapsedTime,
        setElapsedTime: groupChatContext.setElapsedTime,
        setSearchedMessageThread: groupChatContext.setSearchedMessageThread,
        setHighlightedMessageId: groupChatContext.setHighlightedMessageId,
        callData: groupChatContext.callData,
        messages: groupChatContext.messages,
        setMessages: groupChatContext.setMessages,
        isUrgentMessage : groupChatContext.isUrgentMessage,
        setIsUrgentMessage: groupChatContext.setIsUrgentMessage,
        selectedChatTab: groupChatContext.selectedChatTab,
    }));

    const isElapsedTimeZero = elapsedTime.hours === 0 && elapsedTime.minutes === 0 && elapsedTime.seconds === 0;

    const selectedLocationId = selectedChat?.location?.id || selectedChat?.location_id;
    const { data: locationConfigurationData } = useGetLocationConfigurationQuery(
        { location_id: selectedLocationId },
        { skip: !selectedLocationId || !isPatientChatMessage(selectedChat) }
    );
    const locationConfiguration = locationConfigurationData?.data || {};
    const showAppointment = isEnabled(locationConfiguration?.show_appointment);
    const showAllergiesMeds = isEnabled(locationConfiguration?.show_allergies) || isEnabled(locationConfiguration?.show_medication);

    if (!isPatientChatMessage(selectedChat) || showAppointment) {
        actionOptions.unshift({ slug: 'scheduler', label: 'Scheduler', from: 'actions' })
    }

    if (isPatientChatMessage(selectedChat)) {
        actionOptions.unshift({ slug: 'patient_encounters', label: 'Encounters', from: 'actions' })
        if (showAllergiesMeds) {
            actionOptions.unshift({ slug: 'allergies_meds', label: 'Allergies & Meds', from: 'actions' })
        }
    }
    if (isPatientChatMessage(selectedChat) && authData?.is_provider) {
        actionOptions.unshift({ slug: 'letter_orders', label: 'Letters/Orders', from: 'actions' })
    }
    if (isPatientChatMessage(selectedChat) && !authData?.is_provider) {
        actionOptions.unshift({ slug: 'referral_form', label: 'Add Referral', from: 'actions' })
        if (practice_id !== OptimalCarePracticeID && showAppointment) {
            actionOptions.unshift({ slug: 'request_appointment', label: 'Request Appointment', from: 'actions' })
        }
    }

    const { data: problemsMetaData, isLoading: loadingProblems, refetch: refetchProblems } =
        useGetPatientQuestionsQuery({
            deactivated_problems: 0
        });

    useEffect(() => {
        if (problemsMetaData) {
            setProblemsMeta({});
            setReportOptions([]);

            const options = [...defaultOptions];
            const problemsObj = {};

            (problemsMetaData?.response?.data || []).forEach((item) => {
                problemsObj[item.title] = { slug: item.title, label: item.title, ...item };
                options.unshift({ slug: item.title, label: item.title }); // Now modifying a new array
            });

            setReportOptions(options);
            setProblemsMeta(problemsObj);
        }

        let intervalId;
        if (isStopwatchActive) {
            intervalId = setInterval(() => {
                const now = Date.now();
                const diff = now - startTime;
                const hours = Math.floor(diff / 3600000);
                const minutes = Math.floor((diff % 3600000) / 60000);
                const seconds = Math.floor((diff % 60000) / 1000);

                setElapsedTime({ hours, minutes, seconds });
            }, 1000);
            return () => clearInterval(intervalId);
        }

        if (isElapsedTimeZero) {
            setFormState({
                ...formState,
                activity: '',
                provider: '',
                comments: '',
                date: moment(),
            });
        }
    }, [problemsMetaData, isStopwatchActive, isElapsedTimeZero]);

    const onCancelStopwatch = () => {
        setIsOpenStopWatchPopup(false);
        if (isElapsedTimeZero || isStopwatchPaused) {
            setIsStopwatchActive(false);
            setIsStopwatchPaused(true);
            setElapsedTime({ hours: 0, minutes: 0, seconds: 0 });
            setFormState({
                ...formState,
                hours: '00',
                minutes: '00',
                seconds: '00'
            });
        }
    };

    const [getNotifyUsers, { isFetching: isLoadingNotifyUsers }] = chatApi.endpoints.getNotifyUsers.useLazyQuery();

    const onClickCallDialer = async () => {
        if (callData?.call_sid) {
            toast.error("A call is already in progress.")
        }
        else {
            const notifyUsers = await getNotifyUsers({ type: 'call', location_id: selectedChat?.location?.id });

            if (notifyUsers?.data?.names) {
                let ackMsg = 'Call will be routed to the following providers, on ethizo app or phone. <br />'
                ackMsg += '<b>' + notifyUsers.data.names + '</b>'
                setShowAcknowledgement({ isOpen: true, msg: ackMsg })
            }
            else {
                toast.warning("If you need the immediate assistance, kindly call the provider via phone. No provider will receive call at the moment.")
            }
        }

    }


    const handleViewMembers = () => {
        setIsOpenMembersPopup(true);
    }

    const footerListForAcknowledgement = [
        {
            title: "Cancel",
            type: "cancel",
            action: () => {
                setShowAcknowledgement({ isOpen: false });
            }
        },
        {
            title: "OK",
            type: "save",
            action: () => {
                setShowAcknowledgement({ isOpen: false });
                setIsOpenDialer(true)
            }
        }
    ]

    const closeTwillioDialer = () => {
        setIsOpenDialer(false)
    }


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuWrapperRef.current && !menuWrapperRef.current.contains(event.target)) {
                setSearchKeyword("")
                setSearchMessages([]);
            }
        };

        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);

    useEffect(() => {
        setSearchKeyword('')
        setWantsToSearchMessage('')
    }, [selectedChat])

    const showMsgSearch = () => {
        setWantsToSearchMessage(true);
        setTimeout(() => {
            const searchInput = document.getElementById('message_search');
            if (searchInput) {
                searchInput.focus();
            }
        }, 10)
    }

    const handleMessageSearch = (e) => {
        const pressedKey = e.key;
        if (pressedKey == "Enter") {
            const searchVal = e.target.value;
            if (searchVal.trim()) {
                searchMessage(searchVal)
            }
        }
    }

    const handleMessageSearchChange = (val) => {
        setSearchKeyword(val)
        searchMessage(val)
    }

    const handleUrgentMessageChange = (val) => {
        if(val == true){
            setIsUrgentMessage(1);
            if(selectedChatTab != "location_chats"){
                loadUrgentMessage(1);

            }
        }else{
            setIsUrgentMessage(0);
            loadUrgentMessage(0);
        }
    }
    useEffect(() => {
        if (urgentCheckboxRef.current) {
          urgentCheckboxRef.current.checked = isUrgentMessage;
        }
      }, [isUrgentMessage]);

    const loadUrgentMessage = async (val) => {
        try {
          let response = {};
          if(isPatientChatMessage(selectedChat)){
            response = await getPatientChats({
              pid: selectedChat?.pid,
              limit: 50,
              urgent: val,
            });
          } else {
            response = await getLocationChatMessages({
              location_id: selectedChat?.location_id,
              limit: 50,
              urgent: val,
            });
          }
          if(response?.data?.code === 0){
            setMessages({...messages, data: response.data.data});
          }
        } catch (error) {
          console.error("Error loading urgent messages:", error);
        }
      };
      
    const [getPatientChats] = chatApi.endpoints.getPatientChats.useLazyQuery();
    const [getLocationChatMessages] = chatApi.endpoints.getLocationChatMessages.useLazyQuery();
    const searchMessage = useMemo(() => debounce(async (keyword) => {
        if (!keyword) {
            return false;
        }

        setIsSearchingMessages(true)
        let response = {};
        if(isPatientChatMessage(selectedChat)){
            response = await getPatientChats({ keyword, pid: selectedChat?.pid, limit: 20,urgent: isUrgentMessage});
        }
        else{
            response = await getLocationChatMessages({ keyword, location_id: selectedChat?.location_id, limit: 20 ,urgent: isUrgentMessage});
        }

        setIsSearchingMessages(false)
        if (response?.data?.code == 0) {
            setSearchMessages(response.data.data)
        }
    }, 1000), [selectedChat])

    const onSelectedSearchedMessage = (msg) => {
        setSearchKeyword("")
        setIsSearchingMessages(true);

        const promises = [];
        if(isPatientChatMessage(selectedChat)){
            promises.push(getPatientChats({pid: selectedChat?.pid, limit: 10, before_id: msg.id,urgent: isUrgentMessage}));
            promises.push(getPatientChats({pid: selectedChat?.pid, limit: 10, after_id: msg.id,urgent: isUrgentMessage}));
        }
        else{
            promises.push(getLocationChatMessages({location_id: selectedChat?.location_id, limit: 10, before_id: msg.id,urgent: isUrgentMessage}));
            promises.push(getLocationChatMessages({location_id: selectedChat?.location_id, limit: 10, after_id: msg.id,urgent: isUrgentMessage}));
        }

        Promise.all(promises)
            .then(([response1, respose2]) => {
                setIsSearchingMessages(false);
                let beforeMsgs = [];
                let afterMsgs = []
                if (response1?.data?.code === 0) {
                    beforeMsgs = response1.data.data;
                }
                if (respose2?.data?.code === 0) {
                    afterMsgs = respose2.data.data;
                }

                setSearchedMessageThread({ thread_id: msg.id, data: [...afterMsgs, msg, ...beforeMsgs] })
                setHighlightedMessageId(msg.id);
                setSearchMessages([]);
            })
            .catch((error) => {
                setIsSearchingMessages(false);
                console.error("Error fetching messages:", error);
            });
    }

    const PatientInfoHeader = () => {
        const patient = selectedChat?.patient || {};
        const patientName = [patient?.fname, patient?.lname].filter(Boolean).join(' ') || patient?.full_name || patient?.name || '';
        const patientDob = patient?.DOB ? moment(patient.DOB) : null;
        const formattedDob = patientDob?.isValid() ? patientDob.format("MM/DD/YYYY") : '';
        const patientAge = patient?.age !== undefined && patient?.age !== null && patient?.age !== ''
            ? patient.age
            : formattedDob ? calculateAge(patient.DOB) : '';
        const demographics = [
            patient?.sex,
            [formattedDob, patientAge !== '' ? `(${patientAge} Y)` : ''].filter(Boolean).join(' ')
        ].filter(Boolean).join(', ');

        return (
            <div className="flex items-center space-x-4">
                <div className="relative">
                    <div className="h-[42px] w-[42px] shrink-0 rounded-full">
                        <ImgHolder uuid={patient?.file ? patient?.file : patient?.sex} />
                    </div>
                </div>
                <div className="flex flex-col leading-tight items-start">
                    <div className="text-base flex items-center">
                        <span className="text-black-300 font-bold mr-3">{patientName}</span>
                    </div>
                    {patient?.mrn ? <p className="text-sm text-black-300">MRN: {patient.mrn}</p> : null}
                    {demographics ? <p className="text-xs text-black-300 capitalize">{demographics}</p> : null}
                    {selectedChat.location?.name ? <p className="truncate text-xs font-normal text-slate-400" title={selectedChat.location?.name}>{selectedChat.location?.name}</p> : null}
                    <div className="text-xs text-gray-400 flex gap-2 items-center flex-wrap">
                        {patient?.admission_type ? <span title={`Patient Admission Status is ${patient?.admission_type}`}>{patient?.admission_type}</span> : null}
                        {patient?.is_aco_patient ? <span className='font-bold' title="ACO">ACO</span> : null}
                        {patient?.is_hospice ? <span title="Hospice" className="patient-ic-hospice"></span> : null}
                        {patient?.is_homehealth ? <span title="Home Health" className="patient-ic-home-health"></span> : null}
                        {patient?.ccm_status && patient.ccm_status != 'inactive' ? <span title={`Patient's CCM Status is ${patient.ccm_status}`} className="capitalize whitespace-nowrap"><strong>CCM</strong>: {patient.ccm_status}</span> : null}
                        {patient?.rpm_status && patient.rpm_status != 'inactive' ? <span title={`Patient's RPM Status is ${patient.rpm_status}`} className="capitalize whitespace-nowrap"><strong>RPM</strong>: {patient.rpm_status}</span> : null}

                        {patient?.patient_group_color?.map(group => (
                            <span title={group.name} className={`h-4 text-white rounded-md px-1 pb-[1.1rem] whitespace-nowrap`} style={{ backgroundColor: group.color }}>{group.name}</span>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

    const LocationInfoHeader = () => {

        return (
            <div className="flex items-center space-x-4">
                <div className="flex flex-col leading-tight items-start">
                    <div className="text-base flex items-center">
                        <span className="text-black-300 font-bold mr-3">{selectedChat.location?.name}</span>
                    </div>
                    <p className="truncate text-xs font-normal text-slate-400" title={selectedChat.location?.address1}>{selectedChat.location?.address1}</p>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="sticky top-0 z-[1] flex shrink-0 bg-white items-center gap-x-6 border-b-2 border-gray-200 px-3 py-1">
                <div className='w-full min-w-0'>
                    <div className="flex justify-between gap-2 flex-col md:flex-row lg:flex-row xl:flex-row min-w-0">
                        <div className="min-w-0 shrink">
                            {isPatientChatMessage(selectedChat) ? <PatientInfoHeader /> : <LocationInfoHeader />}
                        </div>
                        <div className={`flex ${authData.is_provider && selectedChat.patient?.ccm_status == 'active' ? 'gap-2 lg:gap-4 xl:gap-4' : 'gap-1'} items-center flex-wrap lg:flex-nowrap min-w-0 shrink-0 max-w-full`}>
                            {wantsToSearchMessage ? (
                                <div className='w-full md:w-[250px] lg:w-[250px] xl:w-[250px] relative flex items-center mr-4 shrink min-w-0' ref={menuWrapperRef}>
                                    <input
                                        type="text"
                                        id="message_search"
                                        onChange={(e) => handleMessageSearchChange(e.target.value)}
                                        value={searchKeyword}
                                        maxLength={40}
                                        onKeyDown={(e) => handleMessageSearch(e)}
                                        placeholder="Type here to Search Messages"
                                        className="border-2 rounded-md w-full h-9 px-1 md:pe-[1.75rem] max-w-full"
                                    />
                                    <div onClick={() => setWantsToSearchMessage(false)} className="absolute right-5 bottom-[0.6rem]">
                                        <p
                                            className="cursor-pointer h-5 w-5 text-gray-400"
                                            aria-hidden="true"
                                        >X</p>
                                    </div>
                                    <PushdownMenu
                                        isLoading={IsSearchingMessages}
                                        suggestions={searchMessages}
                                        onSelected={onSelectedSearchedMessage}
                                    />
                                </div>
                            ) :
                                (
                                    <div className='z-10 flex shrink-0' ref={menuWrapperRef}>
                                        <div onClick={showMsgSearch} title="Search messages">
                                            <MagnifyingGlassIcon
                                                className="cursor-pointer h-5 w-5 text-gray-400"
                                                aria-hidden="true"
                                            />
                                        </div>
                                    </div>
                                )}
                            <label className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="urgent_message"
                                    ref={urgentCheckboxRef}
                                    defaultChecked={isUrgentMessage}
                                    onChange={(e)=> handleUrgentMessageChange(e.target.checked)}
                                />
                                <span>Show Urgent</span>
                            </label>
                            <div className='flex gap-2 shrink-0 ml-auto md:ml-0'>
                                {(!authData.is_provider && isPatientChatMessage(selectedChat)) ? (isLoadingNotifyUsers ? (
                                    <div className="h-5 w-5 mt-2 animate-spin border-2 border-green-500 border-t-transparent rounded-full"></div>
                                ) : (
                                    <PhoneIcon onClick={onClickCallDialer} className={`cursor-pointer h-5 w-5 mt-2 text-green-500`} title="Call" />
                                )) : null}
                                {isPatientChatMessage(selectedChat) ? null : <UsersIcon title='View Members' onClick={handleViewMembers} className="h-5 w-5 mt-2 text-teal-500 cursor-pointer" />}

                                {(authData.is_provider && selectedChat.patient?.ccm_status =='active' ) ?
                                    <div id="stopWatch" className="timer mt10 relative inline-block text-left false" 
                                    onClick={() => {setIsOpenStopWatchPopup(true);}} 
                                    title="Stopwatch!"
                                        style={{ width: '130px',height:'37px', borderRadius: '7px' }}>
                                        <p>{formatTime(elapsedTime.hours)}:{formatTime(elapsedTime.minutes)}:{formatTime(elapsedTime.seconds)}</p>
                                    </div>
                                 : null} 
                                {authData?.is_provider || !isPatientChatMessage(selectedChat) ? null :
                                    <BtnMenu
                                        label='Report Problem'
                                        options={reportOptions}
                                        onSelection={(opt) => onSelectHeaderOption(opt)}
                                        menuWidth="w-[270px]"
                                    />
                                }
                                <BtnMenu
                                    label='Actions'
                                    options={actionOptions}
                                    onSelection={(opt) => onSelectHeaderOption(opt)}
                                    menuWidth="w-[110px] md:w-[200px]"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isOpenStopWatchPopup ?
                <MainPageDialog
                    title="Stopwatch"
                    onCancelHandler={() => {
                        onCancelStopwatch();
                    }}
                    modalSize="md"
                    maxHeight={true}
                    component={
                        <StopWatchPopup
                            onCancelHandler={() => {
                                setIsOpenStopWatchPopup(false)
                            }}
                            isStopwatchPaused={isStopwatchPaused}
                            setIsStopwatchPaused={updatesetIsPaused}
                            formState={formState}
                            setFormState={updatesetFormState}
                            startTime={startTime}
                            setStartTime={updatestarttime}

                        >
                        </StopWatchPopup>
                    }
                    footer={false}
                >
                </MainPageDialog>
                : null
            }
            {isOpenDialer ?
                <TwilioDialer closeHandler={closeTwillioDialer} />
                : null
            }

            {showAcknowledgement.isOpen ?
                <MainPageDialog
                    title="Acknowledgement"
                    modalSize="small"
                    maxHeight={true}
                    footerList={footerListForAcknowledgement}
                    onCancelHandler={() => setShowAcknowledgement({ isOpen: false })}
                >
                    <div className=" text-left text-sm text-gray-900">
                        <MarkdownToHtml markdownText={showAcknowledgement.msg} />
                    </div>
                </MainPageDialog>
                : null
            }

            {isOpenMembersPopup ? (
                <MainPageDialog
                    title="Chat Members"
                    onCancelHandler={() => setIsOpenMembersPopup(false)}
                    modalSize="md"
                    maxHeight={true}
                    customHeight={"min-h-[50vh] overflow-y-auto"}
                    component={
                        <ChatMembersPopup />
                    }
                    footer={false}
                ></MainPageDialog>
            ) : null}
        </>
    );
});

export default MessageThreadHeader;